// import Swiper JS
import Swiper, { Autoplay} from 'swiper';
// import Swiper styles
import 'swiper/swiper-bundle.css';

// https://github.com/JayChase/angular2-useful-swiper/issues/48
Swiper.use([Autoplay]);

const swiperEvent = new Swiper('.swiper-event', {
  // Optional parameters
  loop: true,
  slidesPerView: 1,
  breakpoints: {
    // when window width is >= 576px
    576: {
      slidesPerView: 2,
    },
    // when window width is >= 991px
    991: {
      slidesPerView: 3,
    },
  },
  centeredSlides: true,
  spaceBetween: 30,
  // freeMode: true,
  // simulateTouch: true,

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-event-next',
    prevEl: '.swiper-button-event-prev',
  },


});

const swiperNews = new Swiper('.swiper-news', {
  // Optional parameters
  autoplay: {
    delay: 5000,
  },
  loop: true,
  slidesPerView: 1,
  simulateTouch: true,
  autoHeight: true,

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});

const swiperComments = new Swiper('.swiper-comments', {
  // Optional parameters
  autoplay: {
    delay: 5000,
  },
  loop: true,
  slidesPerView: 1,
  simulateTouch: true,
  autoHeight: true,

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});

const swiperPartners = new Swiper('.swiper-partners', {
  // Optional parameters
  autoplay: {
    delay: 5000,
  },
  loop: true,
  breakpoints: {
    // when window width is >= 991px
    1440: {
      slidesPerView: 1,
    },
    // when window width is >= 991px
    1920: {
      slidesPerView: 3,
    },
  },
  centeredSlides: true,
  simulateTouch: true,

  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

  pagination: {
    el: ".swiper-pagination",
  },
});

const swiperMedias = new Swiper('.swiper-medias', {
  // Optional parameters
  autoplay: {
    delay: 5000,
  },
  loop: true,
  slidesPerView: 1,
  simulateTouch: true,
  autoHeight: true,

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});


if (document.getElementById("swiper-button-event-next")) {

  document.getElementById("swiper-button-event-next").addEventListener("click", function(){
    swiperEvent.slideNext(350, true)

  });
  document.getElementById("swiper-button-event-prev").addEventListener("click", function(){
    swiperEvent.slidePrev(350, true)

  });
  document.getElementById("swiper-button-news-next").addEventListener("click", function(){
    swiperNews.slideNext(350, true)

  });
  document.getElementById("swiper-button-news-prev").addEventListener("click", function(){
    swiperNews.slidePrev(350, true)

  });
}


if (document.getElementById("swiper-comments-button-prev")) {
  document.getElementById("swiper-comments-button-next").addEventListener("click", function(){
    swiperComments.slideNext(350, true)

  });
  document.getElementById("swiper-comments-button-prev").addEventListener("click", function(){
    swiperComments.slidePrev(350, true)

  });

}

if (document.getElementById("swiper-partners-button-prev")) {
  document.getElementById("swiper-partners-button-next").addEventListener("click", function(){
    swiperPartners.slideNext(350, true)

  });
  document.getElementById("swiper-partners-button-prev").addEventListener("click", function(){
    swiperPartners.slidePrev(350, true)

  });

}

if (document.getElementById("swiper-partners-button-prev")) {
  document.getElementById("swiper-partners-button-next").addEventListener("click", function(){
    swiperMedias.slideNext(350, true)

  });
  document.getElementById("swiper-partners-button-prev").addEventListener("click", function(){
    swiperMedias.slidePrev(350, true)

  });

}

